import "./DetailsDuTournoi.module.css";
import Header from "@/reusable_sections/Header";
import TournamentOverview from "./sections/TournamentOverview";
import TournamentDetails from "./sections/TournamentDetails";
import TeamRegistration from "./sections/TeamRegistration";
import SimilarTournaments from "./sections/SimilarTournaments";
import Footer from "@/reusable_sections/Footer";
export default function DetailsDuTournoiPage() {
  return <div>
      <Header />
      <TournamentOverview />
      <TournamentDetails />
      <TeamRegistration />
      <SimilarTournaments />
      <Footer />
    </div>;
}